import { Card, Elevation, Spinner } from "@blueprintjs/core";
import React from "react";
import { FaDumpsterFire } from "react-icons/fa";

import styles from "./LoadingDialog.module.css";

export interface LoadingDialogProps {
  title: string;
  message: string;
}

function LoadingDialog(props: LoadingDialogProps): JSX.Element {
  return (
    <Card className={styles.card} elevation={Elevation.THREE}>
      <h2>{props.title}</h2>
      <p>{props.message}...</p>
      <Spinner />
    </Card>
  );
}

export default LoadingDialog;
